/*
 * pb-svg.js — runtime of the « Illustration SVG » widget (CmsSvg).
 *
 * The widget's CSS pauses the SVG's animations while it is off-screen, but only
 * once this runtime has marked the node live (data-pbsvg-live): without JS, or in
 * the editor canvas where this file is not loaded, everything simply plays.
 * Idempotent; re-scans DOM insertions (Blazor circuits, interactive islands).
 */
(function () {
  if (window.__pdSvgRuntime) return;
  window.__pdSvgRuntime = true;

  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.target.classList.toggle('is-visible', e.isIntersecting); });
      }, { rootMargin: '96px 0px' })
    : null;

  function attach(el) {
    if (el.hasAttribute('data-pbsvg-live')) return;
    el.setAttribute('data-pbsvg-live', '');
    if (io && el.getAttribute('data-play-visible') === 'true') io.observe(el);
    else el.classList.add('is-visible');
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('[data-pb-svg]')) attach(root);
    root.querySelectorAll('[data-pb-svg]').forEach(attach);
  }

  scan(document);
  new MutationObserver(function (muts) {
    muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
